// [true, false]
export default class PriorToConsentRule {
    isSupport(filters, node) {
        if(filters.prior_to_consent_filter.length === 1 && !filters.prior_to_consent_filter[0] && !node.data.attributes.is_prior_to_consent){
            return true;
        }
        return false;
    }
    getColor(filters, node) {
        let prevalence = Math.round(node.data.attributes.relative_prevalence * 100);
        if (prevalence >= 0 && prevalence <= 24) {
            return '#DFDFED';
        } else if (prevalence >= 25 && prevalence <= 49) {
            return '#C1C1DC';
        } else if (prevalence >= 50 && prevalence <= 74) {
            return '#A2A2CB';
        } else if (prevalence >= 75 && prevalence <= 99) {
            return '#8383BA';
        } else {
            return '#6565A9';
        }
    }
    getTextColor() {
        return '#411F90';
    }
    getNodeBackgroundColor() {
       return '#FFFFFF';
    }
    getOpacity(filters, node) {
        if((Math.round(node.data.attributes.relative_prevalence * 100)) <= 5){
            return 0.05;
        }
        return node.data.attributes.relative_prevalence;
    }
}
